import { Button, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AxiosError } from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { loginSuperAdmin } from "../../redux/actions/SuperadminActions";
import { server } from "../../common";

const initialValues = {
  email: "",
  password: "",
};

const SuperadminLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    values,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Enter a valid email")
        .required("Please Enter Your Email"),
      password: Yup.string()
        .min(2, "Enter details")
        .required("Please Enter Your password"),
    }),

    onSubmit: (values, action) => {
      console.log(values);
      server
        .post(
          "/admin/loginwithemail",
          values,

          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              dispatch(loginSuperAdmin({ authToken: response.data.token }));
              toast.success("Super Admin Login successfully");
              navigate("/superadmin/contactentries");
              resetForm();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  });

  return (
    <section className="vh-100">
      <div className="container py-3 h-100 ">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-6 col-xl-5">
            <div className="card shadow rounded-3">
              <div className="card-body text-center p-5">
                <img
                  src="/images/logo.jpeg"
                  className="img-fluid"
                  width="300"
                  alt=""
                />
                <h2 className="mb-2text-center ">Super Admin Login</h2>
                <form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <TextField
                      name="email"
                      margin="dense"
                      type="email"
                      placeholder="Lorem Ipsum"
                      variant="outlined"
                      label="Email Id"
                      value={values.email}
                      onChange={handleChange}
                      fullWidth
                      required
                    ></TextField>
                    {errors.email ? (
                      <p className="text-danger">{errors.email}</p>
                    ) : null}
                  </div>

                  <div className="mb-2">
                    <TextField
                      name="password"
                      margin="dense"
                      type="password"
                      placeholder="Password"
                      variant="outlined"
                      label="Password"
                      value={values.password}
                      onChange={handleChange}
                      fullWidth
                      required
                    ></TextField>
                    {errors.password ? (
                      <p className="text-danger">{errors.password}</p>
                    ) : null}
                  </div>
                  <Button
                    variant="contained"
                    className="btn text-white btn-lg btn-block w-100"
                    type="submit"
                  >
                    Login
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuperadminLogin;
